import {contextify, createRootContextHook} from 'common/util/react';
import {EventsController} from 'common/query-builder/query-block/contexts/events-controller';

const context = contextify<EventsController>();

export const EventsControllerProvider = context.Provider;
export const EventsControllerConsumer = context.Consumer;
export const useEventsController = createRootContextHook(`eventsController`);
